import UIComponent from "../../ui/component";

export class SubscriptionSettings extends UIComponent {
    init() {
        this.switch?.on("change", () => {
            this.updateContent();
        });

        this.updateContent();
    }

    updateContent() {
        if (!this.description) return;

        const isChecked = this.switch?.element?.checked || false;

        if (isChecked) {
            this.description.element.textContent = this.text_on;
        } else {
            this.description.element.textContent =  this.text_off;
        }
    }
}
